import { Box } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import React from 'react';
import chroma from 'chroma-js';
import { pxToRem } from '@withjoy/joykit/theme';
import { PAGE_PADDING_VERTICAL } from './Page.constants';

// 'auto' lets the layout decide (multi-page padded, single-page not); 'visible'/'hidden' force it.
export type PageTopPadding = 'auto' | 'visible' | 'hidden';

interface PageProps
  extends Readonly<{
      applicatorProp: object;
      showBorder?: boolean;
      noTranslucency?: boolean;
      customBackgroundColor?: string;
      customTextColor?: string;
      isSinglePage?: boolean;
      topPadding?: PageTopPadding;
    }>,
    HtmlProps<HTMLElement> {}

const getBackgroundColor = (noTranslucency?: boolean, customBackgroundColor?: string) => {
  if (customBackgroundColor) {
    return noTranslucency ? `${customBackgroundColor} !important` : `${chroma(customBackgroundColor).alpha(0.7).css()} !important`;
  }
  return noTranslucency ? 'white !important' : 'white';
};

const Page: React.FC<PageProps> = ({
  applicatorProp,
  showBorder = true,
  noTranslucency,
  customBackgroundColor,
  customTextColor,
  isSinglePage = false,
  topPadding = 'auto',
  children,
  ...restProps
}) => {
  const hasTopPadding = topPadding === 'visible' || (topPadding === 'auto' && !isSinglePage);
  return (
    <Box
      paddingBottom={{ _: pxToRem(54), sm2: PAGE_PADDING_VERTICAL }}
      paddingTop={hasTopPadding ? { xxs: 0, sm4: PAGE_PADDING_VERTICAL } : 0}
      minHeight={'100vh'}
      backgroundColor={getBackgroundColor(noTranslucency, customBackgroundColor)}
      {...(customTextColor && { color: customTextColor })}
      position="relative"
      boxShadow={showBorder ? [null, null, '0px 30px 60px -12px rgba(68, 50, 93, 0.25), 0px 18px 36px -18px rgba(0, 0, 0, 0.3)'] : undefined}
      transition={animationTransition('background-color')}
      {...applicatorProp}
      {...restProps}
    >
      {children}
    </Box>
  );
};

Page.displayName = 'Page';

export { Page };
